<template>
  <main
    id="main"
    role="main"
    :class="className"
  >
    <slot />

    <!-- gap before footer coz of footer waves -->
    <div
      v-if="(isDesktop && includeFooterGap) || BrowserService.isMobileWebview()"
      class="c-py-6 c-lg:c-py-7 c-xl:c-py-8"
    />
  </main>
</template>

<script setup>
import { computed } from 'vue'

import BrowserService from '@/services/browserService'

const props = defineProps({
  backgroundColor: {
    type: String,
    default: 'bg-primary-200',
    validator: (value) => value.includes('bg-'),
  },

  includeFooterGap: {
    type: Boolean,
    default: true,
  },
  includeHeaderGap: {
    type: Boolean,
    default: true,
  },
})

const className = computed(() => {
  return [props.includeHeaderGap ? 'flex-grow-1 c-pt-2 c-sm:c-pt-5' : '', props.backgroundColor].join(' ')
})

const isDesktop = computed(() => {
  return BrowserService.isDesktop()
})
</script>
